module.exports = __webpack_public_path__ + "img/building-75.6286f326.svg";